import axios from 'axios'
import errorParser from '@/utils/error-parser'

//
// Dashboard API: config (org default + per-user override) and tile data.
// All endpoints are plan-gated server-side (PRO/ENTERPRISE/LEGACY or the
// DASHBOARD addon for BASIC).
//
export default {
  /** Effective config: the user's own dashboard, else the org default. */
  getDashboard () {
    return new Promise((resolve, reject) => {
      axios.get('/dashboard').then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  /** Save the calling user's personal dashboard. */
  saveUserDashboard (config) {
    return new Promise((resolve, reject) => {
      axios.put('/dashboard', { config }).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  /** Remove the personal dashboard — back to the org default. */
  deleteUserDashboard () {
    return new Promise((resolve, reject) => {
      axios.delete('/dashboard').then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  /** Save the organization default dashboard (admins only). */
  saveOrganizationDashboard (config) {
    return new Promise((resolve, reject) => {
      axios.put('/dashboard/organization', { config }).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  /** Period data (current/previous/comparison) for the given tiles. */
  getTileData (tiles) {
    return new Promise((resolve, reject) => {
      axios.post('/dashboard/data', { tiles }).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  }
}
